import { Button } from "../components/ui/button";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import { AutopilotFeed } from "../components/autopilot/AutopilotFeed";
import { AutopilotConfig } from "../models/Autopilot";
import { collection, query, where, limit, getDocs } from "firebase/firestore";
import { db } from "../services/Firebase";

import type { PendingTopicData } from "../components/autopilot/TopicCard";

export default function PostIdeasSection({
  linkedIdea,
  onCloseLinkedIdea,
  page = false,
  onOpenDrafts,
}: {
  linkedIdea?: PendingTopicData;
  onCloseLinkedIdea?: () => void;
  page?: boolean;
  onOpenDrafts?: () => void;
}) {
  const { currentUser, activeWorkspaceId } = useAuth();
  const [config, setConfig] = useState<AutopilotConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const fetchConfig = useCallback(async () => {
    if (!currentUser || !activeWorkspaceId) return;
    setLoadError(false);
    setLoading(true);
    try {
      const snap = await getDocs(
        query(
          collection(db, "autopilot_configs"),
          where("userId", "==", activeWorkspaceId),
          limit(1),
        ),
      );
      const cfg = snap.empty
        ? null
        : ({
            id: snap.docs[0].id,
            ...snap.docs[0].data(),
          } as unknown as AutopilotConfig);
      setConfig(cfg);
    } catch (error) {
      console.error("Failed to fetch autopilot config:", error);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [currentUser, activeWorkspaceId]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <>
      {loadError && (
        <div role="alert" className="py-3 text-center text-sm">
          Couldn’t load source settings.{" "}
          <Button variant="link" onClick={fetchConfig}>
            Try again
          </Button>
        </div>
      )}
      <AutopilotFeed
        linkedIdea={linkedIdea}
        onCloseLinkedIdea={onCloseLinkedIdea}
        embedded={!page}
        page={page}
        onOpenDrafts={onOpenDrafts}
        config={config}
        configLoading={loading || loadError}
        onConfigUpdated={fetchConfig}
      />
    </>
  );
}
